import { useState, useRef } from "react";

interface OTPInputProps {
  setOtp: (otp: string) => void; 
}

export function OTPInput({ setOtp }: OTPInputProps) {
  const otpLength = 4;
  const inputRefs = useRef<(HTMLInputElement | null)[]>(Array(otpLength).fill(null));
  const [otpValues, setOtpValues] = useState<string[]>(Array(otpLength).fill(""));

  const handleChange = (index: number, value: string) => {
    if (!/^\d*$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    setOtp(newOtpValues.join(""));

    if (value && index < otpLength - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace") {
      if (!otpValues[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
      const newOtpValues = [...otpValues];
      newOtpValues[index] = "";
      setOtpValues(newOtpValues);
      setOtp(newOtpValues.join(""));
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      const otpArray = pastedData.split("");
      setOtpValues(otpArray);
      setOtp(pastedData);
      otpArray.forEach((digit, idx) => {
        if (inputRefs.current[idx]) {
          inputRefs.current[idx]!.value = digit;
        }
      });
      inputRefs.current[otpLength - 1]?.focus();
    }
  };

  return (
    <div className="flex space-x-2">
      {otpValues.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          className="w-10 h-10 text-center border border-gray-300 rounded-md text-lg font-semibold focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500"
        />
      ))}
    </div>
  );
}
